import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { imgUrl } from "../lib/api";
import { getRecent, removeRecent } from "../lib/recentlyViewed";

export default function RecentlyViewed({ exclude, title = "Recently Viewed" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getRecent().filter((p) => p.id !== exclude));
  }, [exclude]);

  if (!items.length) return null;

  const remove = (id) => setItems(removeRecent(id).filter((p) => p.id !== exclude));

  return (
    <section className="mt-24" data-testid="recently-viewed">
      <h2 className="text-3xl tracking-tight font-semibold mb-10">{title}</h2>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-6">
        {items.slice(0, 6).map((p) => {
          const price = p.sale_price || p.price;
          return (
            <div key={p.id} className="group relative" data-testid={`recent-${p.slug}`}>
              <Link to={`/product/${p.slug}`}>
                <div className="relative overflow-hidden bg-white border border-black/10">
                  <img src={imgUrl(p.image)} alt={p.name} loading="lazy" className="w-full aspect-square object-cover transition-transform duration-500 group-hover:scale-105" />
                  {p.stock <= 0 && <span className="absolute bottom-2 left-2 bg-[#111] text-[#FAF9F6] text-[9px] uppercase tracking-widest px-2 py-0.5">Sold Out</span>}
                </div>
                <p className="font-serif text-sm mt-2 leading-snug line-clamp-1">{p.name}</p>
                <p className="text-xs mt-0.5 font-medium">₹{price?.toLocaleString("en-IN")}</p>
              </Link>
              <button onClick={() => remove(p.id)} aria-label="Remove from recently viewed" data-testid={`recent-remove-${p.slug}`}
                className="absolute top-2 right-2 bg-white/80 backdrop-blur p-1 border border-black/10 hover:text-destructive transition-colors duration-300">
                <X strokeWidth={1.5} size={12} />
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
